import firebase from 'firebase';
//import 'firebase/firestore';

// firebase init goes here
const configOptions = {
    apiKey: "AIzaSyC4-qtRzqsdNUm7EpGBFD0AHRKYwPW7JR4",
    authDomain: "joeradman.firebaseapp.com",
    databaseURL: "https://joeradman.firebaseio.com",
    projectId: "joeradman",
    storageBucket: "joeradman.appspot.com",
    messagingSenderId: "573954946480",
    appId: "1:573954946480:web:12ce010ddcd433e3f09275"
  };

firebase.initializeApp(configOptions);


// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const currentUser = auth.currentUser;

// firebase collections
const destinationsCollection = db.collection('destinations');

export {
    db,
    auth,
    currentUser,
    destinationsCollection
};
